type PdfBadgeIconProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
};

const PdfBadgeIcon = ({
  className,
  width = 36,
  height = 24,
}: PdfBadgeIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect width="36" height="24" rx="4" fill="#FF7178" />
      <path
        d="M7.21094 16V7.51562H10.2344C12.2031 7.51562 13.1758 8.69922 13.1758 10.2695C13.1758 11.8281 12.2031 13.0234 10.2344 13.0234H8.5V16H7.21094ZM8.5 11.9219H10.1055C11.3594 11.9219 11.875 11.2188 11.875 10.2695C11.875 9.30859 11.3594 8.61719 10.1055 8.61719H8.5V11.9219ZM17.7891 16H15.0352V7.51562H17.8711C20.3672 7.51562 21.8672 9.10938 21.8672 11.7461C21.8672 14.3945 20.3672 16 17.7891 16ZM16.3242 14.875H17.7188C19.6406 14.875 20.5898 13.75 20.5898 11.7461C20.5898 9.75391 19.6406 8.64062 17.7891 8.64062H16.3242V14.875ZM23.8203 16V7.51562H29.082V8.62891H25.1094V11.1953H28.707V12.2969H25.1094V16H23.8203Z"
        fill="white"
      />
    </svg>
  );
};

export default PdfBadgeIcon;
